import { check, email, InferOutput, pipe, string } from 'valibot'

export const EmailSchema = pipe(
  string(), 
  email(), // Validates email format
  check((value) => value.length <= 320, 'Email exceeds maximum length') // RFC 5321 limit
)

export type Email = InferOutput<typeof EmailSchema>
